// JsFromRoutes CacheKey 068f17cb76fe7d02ff0344414fe368ac
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client"

export default {
  index: /* #__PURE__ */ definePathHelper("get", "/api/:venue_slug/sponsorship/companies"),
  create: /* #__PURE__ */ definePathHelper("post", "/api/:venue_slug/sponsorship/companies"),
  show: /* #__PURE__ */ definePathHelper("get", "/api/:venue_slug/sponsorship/companies/:id"),
  update: /* #__PURE__ */ definePathHelper("patch", "/api/:venue_slug/sponsorship/companies/:id"),
  destroy: /* #__PURE__ */ definePathHelper("delete", "/api/:venue_slug/sponsorship/companies/:id"),
}
